import { render } from "./NoticeRead.vue?vue&type=template&id=2f217a33&scoped=true"
import script from "./NoticeRead.vue?vue&type=script&lang=js"
export * from "./NoticeRead.vue?vue&type=script&lang=js"

import "./NoticeRead.vue?vue&type=style&index=0&id=2f217a33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f217a33"]])

export default __exports__